import { getApiConfig } from './../../../utilities/index';
import { loadingDialog_show, errorBox_Show } from './../../../actions/A_Popups';
import {POPUP_FILTER_ASSIGN_TO_STONE} from './../../../constants/actionTypes';

export const ActionTypes = {
  GET_STONES_LOADING: 'filters/stones-get-loading',
  GET_STONES_LOADED: 'filters/stones-get-loaded',
  MARK_STONE_CHECKED: 'filters/stone-mark-checked',
  MARK_ALL_STONES_CHECKED: 'filters/stone-mark-all-checked'
}

export const getStones = (term = '', page = 0) => {
    return dispatch => {
      dispatch({type: ActionTypes.GET_STONES_LOADING, payload: {term, page}});
      dispatch(loadingDialog_show(true, 'Loading...', 'Loading stones...'));

      return getApiConfig('Filters/GetStones')
        .post({
          filterBy: {term},
          page: page
        })
        .then(result => {
          dispatch({type: ActionTypes.GET_STONES_LOADED, payload: result});
          dispatch(loadingDialog_show(false));
        })
    }
}

export const selectStone = (stone, select) => {
  return {type: ActionTypes.MARK_STONE_CHECKED, payload: {stone, select}};
}

export const selectAllStones = select => {
  return {type: ActionTypes.MARK_ALL_STONES_CHECKED, payload: {select}};
}

export const showAssignPopup = show => {
  return {type: POPUP_FILTER_ASSIGN_TO_STONE, payload: {show}}
}

